import { LuDownload } from 'react-icons/lu'
import { PropTypes } from 'prop-types'

const RoomDetail = ({
  images,
  noOfStudentRoom,
  noOfStudentApartment,
  advancePayment,
  rentalMonth,
  rentalInformationBrochureDownload
}) => {
  return (
    <div className='flex flex-col gap-5'>
      <div className='grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-5 w-full h-[70rem] md:h-80'>
        {images?.map((img, i) => (
          <div
            key={i}
            className='w-full h-full bg-gray-200 rounded shadow bg-center bg-cover bg-no-repeat'
            style={{ backgroundImage: `url(${img})` }}
          ></div>
        ))}
      </div>
      <div className='flex flex-col gap-2'>
        <span className='text-neutral-800 text-base font-semibold leading-relaxed'>
          No. of Student / Room : {noOfStudentRoom}
        </span>
        <span className='text-neutral-800 text-base font-semibold leading-relaxed'>
          No. of Student / Apartment : {noOfStudentApartment}
        </span>
        <span className='text-neutral-800 text-base font-semibold leading-relaxed flex flex-col'>
          Advance Payment : <span>{advancePayment}</span>
        </span>

        <span className='text-neutral-800 text-base font-semibold leading-relaxed flex flex-col'>
          Rental / Month :
          <div className='flex items-center gap-3'>
            <span>{rentalMonth}</span>
            {rentalInformationBrochureDownload && (
              <a href={rentalInformationBrochureDownload} download>
                <LuDownload size={20} />
              </a>
            )}
          </div>
        </span>
      </div>
    </div>
  )
}
RoomDetail.propTypes = {
  images: PropTypes.array,
  noOfStudentRoom: PropTypes.string,
  noOfStudentApartment: PropTypes.string,
  advancePayment: PropTypes.string,
  rentalMonth: PropTypes.string,
  rentalInformationBrochureDownload: PropTypes.string
}
export default RoomDetail
